import { defineVuePlugin } from '#/vue-plugins'

import { forbiddenErrorHandler, unauthorisedErrorHandler } from '@/config/middleware/auth'

import { client as intranetClient } from '@/shared/api/intranet/client.gen'

export default defineVuePlugin(async () => {
  const handleError = (response: Response) => {
    switch (response.status) {
      case 401:
        return unauthorisedErrorHandler(response)
      case 403:
        return forbiddenErrorHandler(response)
      default:
        return response
    }
  }

  intranetClient.interceptors.response.use(async (response) => {
    return await handleError(response)
  })
})
